module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/charts/chart-pie/chart-pie.component.scss
// module id = ./src/app/shared/charts/chart-pie/chart-pie.component.scss
// module chunks = main